<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hrD1hK/tc-custom/9781439667576.jpg?1702409237077" alt="This image is the cover for the book The Girl Guards of Wyoming"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Girl Guards of Wyoming
      </h1>
      <p class="bookDescription body article font2">
        <p>In the summer of 1890, an army of teenage women with swords drawn and rifles at the ready marched resolutely toward the state capitol to deliver a message to Governor Francis E. Warren and the nation: women want equal rights. As Company K walked alongside women's suffrage pioneer Esther Morris, one could hear the rhythm of their feet keeping step in perfect cadence. Western history remembers murderers, outlaws, prostitutes and saloon girls but not the famous Girl Guards, whose military precision rivaled that of West Point cadets. Author Dan J. Lyon offers the definitive and evocative account of the young women warriors who defined the Equality State.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dan J Lyom, Jim Allison
      </h2>
      
      <p class="authorDescription body article">Dan J. Lyon is a local historian and journalist with extensive military experience. Dan has won top awards in National Collegiate Press Association competition and volunteers at the Warren ICBM and Heritage Museum, Wyoming National Guard Museum and Fort D.A. Russell Open House, as well as in classrooms and at his church. He is a member of the Warren Military Historic Association, the Laramie County Chapter of the Wyoming State Historical Society and the Cheyenne Genealogical and Historical Society.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6da44698